<template lang="pug">
.autocomplete-item
    img(v-if="image" :src="image.url" :height="image.height" :width="image.width")
    .placeholder(v-else)
    .fluid.flex-row
        .name.grow {{ product.name }}
        .stock-info(v-if="product.manage_stock")
            .out-of-stock(v-if="qty <= 0")
                | {{ $t('Out of stock') }}
                i.el-icon-fa-exclamation-triangle.fas
            .in-stock(v-else v-html="$t('In stock: <b>{qty}</b>', { qty })")
    .flex-row
        .grow.product-nr {{ product.nr }}
        .price(:class="{ 'strike-through': salePrice }") {{ price | moneyFormat(currency) }}
        .sale-price(v-if="salePrice") {{ salePrice | moneyFormat(currency) }}
</template>

<i18n>
{
    "en": {
        "In stock: <b>{qty}</b>": "In stock: <b>{qty}</b>"
    },
    "de": {
        "In stock: <b>{qty}</b>": "Auf Lager: <b>{qty}</b>",
        "Out of stock": "Nicht auf Lager"
    }
}
</i18n>

<script>
export default {
    name: 'ProductPreview',
    props: {
        product: {
            type: Object,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
        priceType: {
            type: String,
            required: true,
        },
        customerGroup: {
            type: Object,
            required: false,
        },
    },
    computed: {
        image() {
            const media = _.get(this.product, 'media') || []
            const el = media.find(el => el.type === 'image' && el.list)
                || media.find(el => el.type === 'image')

            if (el && el.image) return el.image
        },
        salePrice() {
            const productPrices = _.get(this.product, 'prices') || []
            const articlePrices = _.get(this.product, 'article.prices') || []

            let price
            if (this.customerGroup) {
                price = articlePrices.find(el => {
                    return el.type === 'sale' && el.customer_group_id == this.customerGroup.id
                }) || productPrices.find(el => {
                    return el.type === 'sale' && el.customer_group_id == this.customerGroup.id
                })
            }

            return _.get(price, `${this.priceType}_value`)
                ? price[`${this.priceType}_value`] + this.surcharge
                : undefined
        },
        price() {
            const productPrices = _.get(this.product, 'prices') || []
            const articlePrices = _.get(this.product, 'article.prices') || []

            let price
            if (this.customerGroup) {
                price = articlePrices.find(el => {
                    return el.type === 'group' && el.customer_group_id == this.customerGroup.id
                }) || productPrices.find(el => {
                    return el.type === 'group' && el.customer_group_id == this.customerGroup.id
                })
            }

            if (!price) {
                price = articlePrices.find(el => el.type === 'main')
                    || productPrices.find(el => el.type === 'main')
            }

            return _.get(price, `${this.priceType}_value`, 0) + this.surcharge
        },
        surcharge() {
            let surcharge = 0

            const properties = _.get(this.product, 'properties') || []
            properties.forEach(el => {
                if (!el.values || el.values.length !== 1) return

                const prices = _.get(el.values[0], 'prices') || []
                const price = prices.find(el => el.customer_group_id == this.customerGroup.id)
                if (price && price.gross_value > 0) surcharge += _.get(price, `${this.priceType}_value`)
            })

            return surcharge
        },
        qty() {
            if (this.customerGroup) return _.get(this.product, `qty.${this.customerGroup.key}`) || 0
            else return _.get(this.product, 'qty.guests') || 0
        },
    }
}
</script>

<style lang="sass" scoped>
.autocomplete-item
    display: grid
    grid-template-columns: min-content auto
    grid-template-rows: auto auto
    column-gap: 0.5rem
    line-height: 1.3
    padding: 0.5rem 0
    img, .placeholder
        grid-row: 1 / span 2
        width: 30px
        height: 40px
        background-color: $color-skeleton
        border: none
        border-radius: 4px
    // .description, .properties
    //     grid-column: 2

// .description
//     max-width: 387px
//     min-width: 1px

.flex-row
    min-width: 0

.fluid
    flex: 1 1 100%
    min-width: 0
    .name
        font-weight: bold
        overflow: hidden
        text-overflow: ellipsis
        white-space: nowrap

.price
    font-weight: bold

.sale-price
    color: $--color-danger
    font-weight: bold

.out-of-stock i
    color: $--color-danger
    margin-left: 0.5rem

.strike-through
    font-weight: 400
    position: relative
    &:before
        position: absolute
        content: ""
        left: -3px
        top: 50%
        right: -3px
        border-top: 1px solid rgba(0,0,0,0.6)
        // border-color: $--color-info
        transform: rotate(-5deg)
</style>
